module.exports = __webpack_public_path__ + "static/img/stator_256.cc8c985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stator_256.png
// module id = ujRy
// module chunks = 0